<template>
  <v-app id="inspire">
    <v-main>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-12">
              <v-toolbar class="primary" dark flat>
                <v-toolbar-title>{{ $t("loginFormLabel") }}</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <v-form  @keyup.native.enter="login">
                  <v-alert type="error" color="secondary" class="mb-8" v-if="serverErrors">
                    {{ serverErrors }}
                  </v-alert>

                  <v-text-field ref="username" required v-model="email" :label="$t('loginLabel')" name="login"
                    prepend-icon="mdi-account" type="text" :rules="usernameRules">
                  </v-text-field>

                  <v-text-field required v-model="password" id="password" :label="$t('passwordLabel')" name="password"
                    prepend-icon="mdi-lock" type="password" :rules="passwordRules">
                  </v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn type="submit" class="primary white--text" @click="login">{{$t("loginLabel")}}</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="auto">
            <v-alert 
              color="blue-grey"
              dark
              dense
              text
              border="top"
              type="info"
            >
              App v. {{appVersion}}, API v. {{apiVersion}}
            </v-alert>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
  import userService from "../services/UserService";
  import {
    mapGetters
  } from "vuex";
  import Vue from "vue";
  import {version} from "../../package.json"
  export default Vue.extend({
    name: "Login",
    data() {
      return {
        serverErrors: '',
        email: "",
        password: "",
        error: "",
        usernameRules: [(v) => !!v || this.$t("usernameValidationLabel")],
        passwordRules: [(v) => !!v || this.$t("passwordValidationLabel")],
        apiVersion:"",
        appVersion: version
      };
    },
    computed: {
      ...mapGetters(["languages"]),
    },
    methods: {
      login() {
        var data = {
          grant_type: "password",
          username: this.email,
          password: this.password,
        };

        userService
          .logIn(data)
          .then((response) => {
            let user = {
              userId: response.data.userId,
              fullName: response.data.userName,
              userType: response.data.userTypeId,
              userTypeDescription: response.data.userTypeDescription,
              companyId: response.data.companyId,
              preferedLanguage: {
                id: response.data.preferedLanguageId,
                name: response.data.preferedLanguageName,
                isO639: response.data.preferedLanguageIso,
              },
            };
            this.$auth.setToken(response.data.access_token);
            this.axios.defaults.headers.common[
              "Authorization"
            ] = `Bearer ${response.data.access_token}`;
            this.$auth.setUser(response.data.userName);
            this.$store.dispatch("storeUser", user);
            this.$router.push({
              name: "DashboardMain",
            });
            this.setLanguage();
            this.fetchLanguages();
          })
          .catch((error) => {
            this.serverErrors = 'Username or Password invalid!'
          });
      },
      setLanguage() {
        this.$i18n.locale = this.$store.getters.getCurrentUser.preferedLanguage.isO639;
      },
      async fetchLanguages() {
        if (this.languages.length > 0) {
          return;
        }
        await this.axios
          .get("api/translate/fetchLanguages")
          .then((response) => {
            console.log(response);
            this.$store.dispatch("setLanguages", response.data);
          })
          .catch((error) => {
            console.log(error);
          });
      },
      async getApiVersion(){
        this.axios
          .get("api/version")
          .then((response) => {
            this.apiVersion = response.data;
          })
          .catch((error) => {
            console.log(error);
            this.apiVersion = "-";
          });
      }
    },
    beforeMount(){
      this.getApiVersion();
    },
    mounted() {
      this.$refs.username.focus()
    }
  });
</script>

<style lang="scss">
</style>